import { Spin } from "antd";

interface Props {
  loading: boolean;
  children: any;
}

const LoadingComponent: React.FC<Props> = ({ loading, children }) => {
  if (loading) {
    return (
      <div className="loader-div">
        <div className="loader">
          <Spin />
        </div>
      </div>
    );
  } else {
    return children;
  }
};

export default LoadingComponent;
